import React, { useCallback, useState } from 'react'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { reqUpdateDeliveryAddress } from 'client/ClientRequests'
import { IDeliveryAddress } from 'client/IClientInfo'
import DeliveryAddressForm from './DeliveryAddressForm'

interface IDeliveryAddressListItemProps {
  address: IDeliveryAddress
  onRemove: (address: IDeliveryAddress) => void
  hideRemoveButton?: boolean
}

const DeliveryAddressListItem: React.FC<IDeliveryAddressListItemProps> = ({
  address: addressProp,
  onRemove,
  hideRemoveButton,
}) => {
  const [address, setAddress] = useState<IDeliveryAddress>(addressProp)
  const [isEdit, setIsEdit] = useState(false)

  // const handleEdit = useCallback((event: React.MouseEvent<HTMLAnchorElement>) => {
  //   event.preventDefault()
  //   setIsEdit(true)
  // }, [])

  const handleRemove = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault()
      setIsEdit(false)
      onRemove(address)
    },
    [address, onRemove]
  )

  const handleUpdateAddress = useCallback((address: IDeliveryAddress) => {
    reqUpdateDeliveryAddress(address, (newAddress) => {
      if (newAddress) {
        setAddress(newAddress)
        setIsEdit(false)
      }
    })
  }, [])

  return (
    <div className='py-2'>
      <div className='d-flex gap-3'>
        г. {address.city_name}, ул. {address.street}, д. {address.building}
        {address.flat && ', кв. ' + address.flat}
        {address.entrance && ', подъезд ' + address.entrance}
        {address.floor ? ', этаж ' + address.floor : ''}
        {!isEdit && !hideRemoveButton && (
          <>
            {/* <a href='/#/' onClick={handleEdit} className='my-link'>
              <FontAwesomeIcon icon={faEdit} size='lg' />
            </a> */}
            <a href='/#/' onClick={handleRemove} className='my-link'>
              <FontAwesomeIcon icon={faTrashAlt} size='lg' color='var(--color-red)' />
            </a>
          </>
        )}
      </div>

      {isEdit && (
        <div className='pl-dynamic' style={{ maxWidth: '700px' }}>
          <DeliveryAddressForm
            key='update'
            address={address}
            onAccept={handleUpdateAddress}
            onCancel={() => {
              setIsEdit(false)
            }}
          />
        </div>
      )}
    </div>
  )
}
export default DeliveryAddressListItem
